<script lang="ts">
    import { redirectTo } from '../js/common';
    import { deglingos, english, hide_cookie_param } from '../store/store';
    import { 
    idPageCgv,
    idPageLegal,
        nameENPageCgv,
        nameENPageLegal,
        nameFRPageCgv,
        nameFRPageLegal
     } from './router/router';

    function open_cookie_param() {
        hide_cookie_param.set(false);
    }
</script>

<style lang="scss">
    .footer {
        grid-area: footer;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        height: 100%;
        color: $color_tertiary;
        font-size: small;
        &__deglingos {
            background-color: $color_primary;
        }
        &__img {
            height: 20px;
            padding: 10px 0 10px 0;
        }
        &__pointer {
            cursor: pointer;
        }
    }

    @include large {
        .footer {
            flex-direction: row;
            justify-content: center;
            align-content: center;
            font-size: 1em;
            &__img {
                padding: 0 0 5px 0;
            }           
        }
        .dot {
            display: none;
        }
    }
</style>

<footer class="footer" class:footer__deglingos={$deglingos}>
    {#if $english}
        <p>&nbsp;.&nbsp;<span class="footer__pointer" on:click={() => redirectTo(idPageLegal)} on:keydown={() => redirectTo(idPageLegal)}>{nameENPageLegal}</span><span class="dot">&nbsp;.&nbsp;</span></p>
        <p>&nbsp;.&nbsp;<span class="footer__pointer" on:click={() => redirectTo(idPageCgv)} on:keydown={() => redirectTo(idPageCgv)}>{nameENPageCgv}</span>&nbsp;.&nbsp;</p>
    {:else}
        <p>&nbsp;.&nbsp;<span class="footer__pointer" on:click={() => redirectTo(idPageLegal)} on:keydown={() => redirectTo(idPageLegal)}>{nameFRPageLegal}</span><span class="dot">&nbsp;.&nbsp;</span></p>
        <p>&nbsp;.&nbsp;<span class="footer__pointer" on:click={() => redirectTo(idPageCgv)} on:keydown={() => redirectTo(idPageCgv)}>{nameFRPageCgv}</span>&nbsp;.&nbsp;</p>
    {/if}
</footer>